export default "__VITE_ASSET__BdnqO3gA__"